const PRINT_RESTITUTION_RECEIPT = {
  title: 'Zé Delivery',
  subtitle: 'Restituição da semana',
  period: 'Período',
  previsionPaymentDate: 'Previsão de Pagamento',
  paymentMethod: 'Forma de pagamento: Transferência bancária [ITAÚ]',
  store: 'Loja',
  address: 'Endereço',
  detailsTitle: 'Detalhamento da Restituição',
  totalRestitutionTitle: 'Total da Restituição',
  footer: 'Dúvidas? Acesse seu.ze ou entre em contato com o suporte',
  restitutionCategories: {
    markup: 'Markup',
    shipping: 'Fretes',
    couponAndDiscount: 'Cupons e Descontos',
    incentive: 'Incentivos',
    marketPlace: 'Taxas e Comissões',
    manualPayment: 'Pagamentos Manuais',
  },
}

export default PRINT_RESTITUTION_RECEIPT
